import { SafeHtml } from '@angular/platform-browser';
import { AdvisorData } from '../../../../../../../lib/advisor/advisor.model';
import { StringHelper } from '../../../../../../../lib/helpers/string.helper';
import { IdVerseStatusIconType, IdVerseStatusType } from './id-verse-status-message.model';

export interface IdVerseStatusData {
  iconType: IdVerseStatusIconType;
  title: string;
  buttonLabel: string;
  body: string | SafeHtml;
}

export const getIdVerseStatusData = (
  type: IdVerseStatusType,
  advisorData?: AdvisorData,
  customerName?: string
): IdVerseStatusData => {
  switch (type) {
    case IdVerseStatusType.Success:
      return getSuccessData();
    case IdVerseStatusType.FailedRetry:
      return getFailedData(false, advisorData);
    case IdVerseStatusType.FailedExpired:
      return getFailedData(true, advisorData);
    case IdVerseStatusType.SwitchToKba:
      return getSwitchToKbaData(advisorData, customerName);
  }
};

const getSuccessData = (): IdVerseStatusData => ({
  iconType: IdVerseStatusIconType.Success,
  title: 'Verification complete',
  buttonLabel: 'CONTINUE',
  body: 'Your identity has been successfully verified. Continue to complete next steps.',
});

const getFailedData = (isExpired: boolean, advisorData?: AdvisorData): IdVerseStatusData => ({
  iconType: IdVerseStatusIconType.Warning,
  title: isExpired ? 'Verification expired' : 'Verification unsuccessful',
  buttonLabel: 'TRY AGAIN',
  body: `We were unable to verify your identity. ${getAdvisorContactInfo(advisorData)}`,
});

const getSwitchToKbaData = (advisorData?: AdvisorData, customerName?: string): IdVerseStatusData => {
  const customerPart = customerName ? ` only ${customerName} can answer` : '';
  const baseMessage = `We were unable to verify your identity with our primary method, hence we are changing the verification method to Knowledge Based Authentication. We'll safely verify your identity with a few questions${customerPart}.`;
  const body = `${baseMessage} ${getAdvisorContactInfo(advisorData)}`;

  return {
    iconType: IdVerseStatusIconType.Warning,
    title: 'Verification unsuccessful',
    buttonLabel: 'CONTINUE',
    body,
  };
};

const getAdvisorContactInfo = (advisorData?: AdvisorData): string => {
  return `In case you need assistance, please contact your Business Advisor${StringHelper.advisorContactFormat(advisorData)} to complete the verification process.`;
};
